import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {HitUtils} from '@hit/components/src/utils/hit/HitUtils';
import {HitOnlineEnums} from 'hit-online-web-ui/src/helpers/constants';
import {translate} from '../../plugins/i18n/i18n';

export default class FileDocument extends BaseModel {
  constructor({
    id,
    number,
    designation,
    active = true,
    memo = null,
    author = null,
    mimeType = null,
    size = null,
    version = null,
    specSheetType = null,
  }) {
    super(id, number, designation);
    this.active = active;
    this.memo = memo;
    this.author = author;
    this.mimeType = mimeType;
    this.size = size;
    this.version = version;
    this.specSheetType = specSheetType
      ? HitOnlineEnums.getEnumValue(
          'TECHNICAL_SPECIFICATION_TYPE',
          specSheetType,
          translate,
        )
      : null;
  }

  static get fkName() {
    return 'document_id';
  }
  static get apiRoute() {
    return 'document';
  }
  static get detailPageRoute() {
    return undefined;
  }
  static get listPageRoute() {
    return 'fileConfig';
  }
  get fkName() {
    return File.fkName;
  }
  get apiRoute() {
    return File.apiRoute;
  }
  get listPageRoute() {
    return File.listPageRoute;
  }
  get detailPageRoute() {
    return File.detailPageRoute;
  }

  static get listDisplayAttrsForHistory() {
    return this.getAttributes(['designation', 'version', 'creationDate']);
  }

  static get joinAttrsKey() {
    return ['designation', 'version', 'creationDate'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['designation', 'id', 'mimeType', 'size']);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['designation', 'mimeType', 'size'], []);
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(['designation', 'mimeType', 'size']);
  }

  static get technicalSpecListDisplayAttrs() {
    return this.getAttributes([
      'designation',
      'mimeType',
      'size',
      'specSheetType',
      'creationDate',
    ]);
  }

  static get allAttributes() {
    return [
      // We need to add ID to the attributes to be able to display the value in the table
      new AT.StringAttribute({
        name: 'id',
        readOnly: true,
        tableProperties: {
          header: 'ID',
          maxWidth: '2fr',
          readOnly: true,
        },
      }),
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '1fr'}),
      this.DESIGNATION_ATTRIBUTE({}, {maxWidth: '2fr'}),
      new AT.StringAttribute({
        name: 'filename',
        readOnly: true,
        tableProperties: {
          readOnly: true,
          header: 'hit-app.view.filename',
          maxWidth: '2fr',
        },
      }),
      this.ACTIVE_ATTRIBUTE(),
      new AT.StringAttribute({
        name: 'memo',
        tableProperties: {
          header: 'hit-base.common.memo',
        },
      }),
      new AT.FkStaffAttribute({
        name: 'author',
        column: 'author_id',
        joinPath: ['fk_document_author_id_staff'],
        fkToUpdate: 'author_id',
        tableProperties: {
          header: 'hit-base.common.author',
        },
      }),
      new AT.StringAttribute({
        name: 'mimeType',
        column: 'mime_type',
        readOnly: true,
        tableProperties: {
          header: 'hit-base.common.type',
          maxWidth: '1fr',
          readOnly: true,
        },
      }),
      new AT.IntegerAttribute({
        name: 'size',
        readOnly: true,
        transform: (x) => HitUtils.convertFileSize(x),
        tableProperties: {
          header: 'hit-app.view.size',
          maxWidth: '1fr',
          readOnly: true,
        },
      }),
      new AT.StringAttribute({
        name: 'version',
        tableProperties: {
          header: 'hit-app.common.version',
        },
      }),
      new AT.EnumerationAttribute({
        name: 'specSheetType',
        column: 'spec_sheet_type',
        enumType: 'TECHNICAL_SPECIFICATION_TYPE',
        enumClass: HitOnlineEnums,
        tableProperties: {
          header: 'hit-app.common.technical-specification',
          maxWidth: '1fr',
          hideByDefault: true,
        },
      }),
      new AT.FkQmDocumentAttribute({
        name: 'qmDocument',
        column: 'qm_document_id',
        joinPath: ['qm_document!fk_document_qm_document_id_qm_document'],
        fkToUpdate: 'qm_document_id',
        tableProperties: {
          header: 'hit-app.common.qm_document_id',
        },
      }),
      new AT.DateTimeAttribute({
        name: 'creationDate',
        column: 'creation_date',
        tableProperties: {
          header: 'hit-app.common.creation-date',
        },
      }),
    ];
  }
}
